import { render, staticRenderFns } from "./BaseItem.vue?vue&type=template&id=4794c06e&lang=pug"
import script from "./BaseItem.vue?vue&type=script&lang=js"
export * from "./BaseItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports